import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';

import {
    Aggregation,
    aggregationOptions,
} from 'components/widgets/ResourcesAnalysisChart/ResourcesAnalysisChart.consts';

interface Props {
    selectedStartDate: number | null;
    selectedEndDate: number | null;
    selectedSeries: string | null;
    selectedValue: string | null;
    aggregation: ISelectOption<Aggregation>;
    dataPointIndex: number | null;
    seriesIndex: number | null;
    update: (value: Unionize<Omit<Props, 'update' | 'reset'>>) => void;
    reset: () => void;
}

const state: StateCreator<Props> = (set) => ({
    selectedStartDate: null,
    selectedEndDate: null,
    selectedSeries: null,
    selectedValue: null,
    aggregation: aggregationOptions.find((item) => item.value === 'P50') || aggregationOptions[0],
    dataPointIndex: null,
    seriesIndex: null,
    update: (value) => set({ ...value }),
    reset: () => set({ selectedStartDate: null, selectedEndDate: null, selectedSeries: null }),
});

export const useResourceAnalysisStore = create(state);
